/**
 * Resolve a `var(--…)` / `light-dark()` / `oklch()` color expression to a
 * concrete `rgb()` string, for the rare JS consumer that must READ a color
 * value (CSS-only consumers don't need this — the cascade resolves natively).
 *
 * Custom-property reads via getComputedStyle(root).getPropertyValue('--x')
 * return the LITERAL `light-dark(…)` string, not a resolved color. The reliable
 * way is a hidden probe: set `color` to the expression and read the computed
 * `color` back. (Extracted from motion/player.ts so there is one resolver.)
 */
export function resolveCssColor(raw: string, host: HTMLElement = document.body): string {
  if (typeof document === 'undefined' || !host) return raw;
  try {
    const probe = document.createElement('span');
    probe.style.color = raw;
    probe.style.display = 'none';
    host.appendChild(probe);
    const computed = getComputedStyle(probe).color;
    host.removeChild(probe);
    return computed || raw;
  } catch {
    return raw; // detached / jsdom
  }
}
